module.exports = __webpack_public_path__ + "static/media/image128.5fc4d646.png";